/* eslint-disable react/require-optimization */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
//Limitless imports
import { AutoComplete, createSuggestions, HeaderIconButton } from "../../..";
import FormFieldLoading from "../form-field-loading/FormFieldLoading";
const CountryCodeDropDown = ({
  classes,
  selectedCountryCode,
  selectedTenants,
  selectedGroups,
  onGroupSelected,
  onCountryCodeSelected,
  groups
}) => {
  const groupSuggestions = () => {
    if (groups.length > 0) {
      if (selectedCountryCode) {
        return createSuggestions(groups.filter(g => g.country === selectedCountryCode), {
          labelDataKey: "groupName",
          includeItemObject: true
        });
      } else {
        return createSuggestions(groups, {
          labelDataKey: "groupName",
          includeItemObject: true
        });
      }
    } else {
      return [];
    }
  };
  const handleChange = value => {
    const selectedGroups = [];
    groups.map(group => {
      if (group.country === value.label) {
        selectedGroups.push(group);
      }
    });
    onCountryCodeSelected(value.label, selectedGroups);
  };
  const handleAddAllGroups = () => {
    onGroupSelected(groupSuggestions());
  };
  const countryCodeSuggestions = (groups === null || groups === void 0 ? void 0 : groups.length) > 0 ? createSuggestions(groups, {
    labelDataKey: "country",
    shouldBeUnique: true
  }) : [];
  if ((selectedTenants === null || selectedTenants === void 0 ? void 0 : selectedTenants.length) === 0) {
    return /*#__PURE__*/React.createElement(FormFieldLoading, {
      label: "Country Code",
      placeholder: "Select a tenant first"
    });
  }
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.countryCodeWrapper
  }, countryCodeSuggestions.length === 1 || selectedCountryCode && selectedGroups.length > 0 ? /*#__PURE__*/React.createElement(FormFieldLoading, {
    label: "Country Code",
    placeholder: selectedCountryCode || groups[0].country
  }) : /*#__PURE__*/React.createElement(AutoComplete, {
    label: "Country Code",
    value: selectedCountryCode ? createSuggestions([selectedCountryCode]) : null,
    placeholder: "Type to search country code",
    id: "countryCodeAutoComplete",
    suggestions: countryCodeSuggestions,
    onChange: handleChange,
    name: "selectedCountryCode",
    isMulti: false
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    label: "Groups",
    value: selectedGroups,
    placeholder: "Type to search groups",
    id: "groupsAutoComplete",
    suggestions: groupSuggestions(),
    onChange: onGroupSelected,
    name: "selectedGroups",
    isMulti: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "addAllGroupsButton",
    onButtonClick: handleAddAllGroups,
    tooltip: "Add all groups",
    icon: /*#__PURE__*/React.createElement(AddCircleOutline, null),
    disabled: (selectedTenants === null || selectedTenants === void 0 ? void 0 : selectedTenants.length) === 0,
    color: "secondary"
  }))));
};
const styles = () => ({
  countryCodeWrapper: {
    marginBottom: 16
  },
  groupWrapper: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginTop: 16
  }
});
export default withStyles(styles)(CountryCodeDropDown);
CountryCodeDropDown.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedTenants: PropTypes.array,
  selectedGroups: PropTypes.array,
  onGroupSelected: PropTypes.func.isRequired,
  onCountryCodeSelected: PropTypes.func.isRequired,
  selectedCountryCode: PropTypes.string,
  groups: PropTypes.array
};
CountryCodeDropDown.defaultProps = {
  selectedTenants: [],
  selectedGroups: []
};